module.exports = __webpack_public_path__ + "img/client-crave.82902dd7.jpeg";